/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/**
 * Defines the Design Language System (DLS) Material Battery Icon component.
 */
export const MaterialBatteryIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_14304_20057)'>
        <path d='M13 14H11V8H13V14ZM13 18H11V16H13V18ZM16.7 4H15V2H9V4H7.3C6.6 4 6 4.6 6 5.3V20.6C6 21.4 6.6 22 7.3 22H16.6C17.3 22 17.9 21.4 17.9 20.7V5.3C18 4.6 17.4 4 16.7 4Z' fill={iconColor} />
      </g>
      <defs>
        <clipPath id='clip0_14304_20057'>
          <rect width='11.9' height='20' fill={dlsColor('white')} transform='translate(6 2)' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MaterialBatteryIcon;
